<template>
  <div
    class="api-tokens-table"
    data-testid="api-tokens-table"
  >
    <AppScrollableTable :has-fixed-column="false">
      <AppTable
        hoverable
        :table-data="tokens"
      >
        <template #empty>
          <div
            class="mt-20 text-center text-muted"
            data-testid="api-tokens-empty-state"
          >
            <i class="hi hi-key hi-24 d-block mb-10" />
            <h4>No access tokens yet</h4>
            <p>Create a token to start using the Hubstaff API.</p>
          </div>
        </template>

        <AppTableColumn
          v-slot="{ row }"
          header="Name"
        >
          {{ row.name }}
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          header="Token"
        >
          <code class="text-muted">hsoat_…{{ row.token_suffix }}</code>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          header="Assigned to"
        >
          <a
            v-if="row.user_url"
            :href="row.user_url"
          >{{ row.user_name }}</a>
          <span v-else>{{ row.user_name }}</span>
          <span
            v-if="row.user_role"
            class="text-muted d-block small"
          >{{ row.user_role }}</span>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          header="Created"
        >
          {{ row.created_at }}
          <span
            v-if="row.created_by_name"
            class="text-muted d-block small"
          >by
            <a
              v-if="row.created_by_url"
              :href="row.created_by_url"
            >{{ row.created_by_name }}</a>
            <template v-else>{{ row.created_by_name }}</template>
          </span>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          header="Expires"
        >
          {{ row.expires_at || 'Never' }}
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          header="Status"
        >
          <span
            :class="statusClass(row)"
            data-testid="api-token-status"
          >{{ statusLabel(row) }}</span>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          class="text-right"
          direction="right"
        >
          <AppButton
            type="primary"
            size="small"
            modifiers="mr-10"
            :disabled="row.expired"
            :data-testid="`reassign-api-token-${row.id}`"
            @click="$emit('reassign', row)"
          >
            Reassign
          </AppButton>
          <AppButton
            type="danger"
            size="small"
            :data-testid="`revoke-api-token-${row.id}`"
            @click="$emit('revoke', row)"
          >
            Revoke
          </AppButton>
        </AppTableColumn>
      </AppTable>
    </AppScrollableTable>
  </div>
</template>

<script>
export default {
  name: 'ApiTokensTable',
  props: {
    tokens: { type: Array, required: true },
  },
  methods: {
    statusLabel(row) {
      if (row.expired) {return 'Expired';}

      return row.needs_reassignment ? 'Needs reassignment' : 'Active';
    },
    statusClass(row) {
      if (row.expired) {return 'label label-default';}

      return row.needs_reassignment ? 'label label-warning' : 'label label-success';
    },
  },
};
</script>
